/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit City/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function City({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Address/Addresses/Content/Address/Edit/Content/Fields/City",
  isInvalid,
  onChange
  
}) {
let editAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'edit_address',
path: 'city',
})
let editAddressCityIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_address',
path: 'city',
validate: fromValidate.textInput,
})
let editAddressCityChangeData = fromData.useDataChange({ viewPath,
context: 'edit_address',
path: 'city',
})
  return (<React.Fragment
>
<div
  data-testid="City.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 label="City"
 marginTop={0}
 data="edit_address.city"
 validate="/Data/validate.js textInput"
 invalid={!editAddressCityIsValidData}
 value={editAddressCityValueData}
 onChange={editAddressCityChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInputWithLabelField>
</div>
{children}
</React.Fragment>)
}